import { login, logout, getInfo, getOrgInfo, getUserGrade } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router from '@/router'
let webInfoSock = '';
let socknum = 5;
const state = {
  token: getToken(),
  name: '',
  avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
  identity_type: '',
  loginId: '',
  mystutab: '',
  infoNum: 0,
  oid: '1',
  infoSend: {},
  grade: '',
  card_info: '',
  card_no: '', // 身份证
  stuVerified: false,
  orgInfo: {},
  closeComment: false, // 是否关闭评论功能, true:关闭,false:不关闭
  arrGrade: []
}
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    if (avatar == '') {
      state.avatar = 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif'
    } else {
      state.avatar = avatar
    }
  },
  SET_IDENTYPE: (state, type) => {
    state.identity_type = type
  },
  SET_LOGINID: (state, id) => {
    state.loginId = id
  },
  SET_STUTAB: (state, tab) => {
    state.mystutab = tab
  },
  SET_OID: (state, oid) => {
    state.oid = oid
  },
  INIT: (state, name) => {
    if (state.token) {
      if (process.env.NODE_ENV == 'development') {
        webInfoSock = new WebSocket(process.env.BASE_GET_WS_URL + "/orgNotification?token=" + state.token + "&os_type=1" + "&oid=" + state.oid);
        // webInfoSock = new WebSocket("ws://ws.course.yiihuu.com:18308/orgNotification?token="+state.token+"&oid="+state.oid+"&os_type=1");
      } else if (process.env.NODE_ENV == 'production') {
        webInfoSock = new WebSocket(process.env.BASE_GET_WS_URL + "/orgNotification?token=" + state.token + "&os_type=1");
      } else {
        webInfoSock = new WebSocket(process.env.BASE_GET_WS_URL + "/orgNotification?token=" + state.token + "&os_type=1");
      }
      webInfoSock.onopen = (evt) => {
        console.log('消息ws开启', evt);
      };
      webInfoSock.onmessage = (evt) => {
        console.log('消息ws开启,接收到广播回来的数据：', evt.data);
        if (evt.data) {
          state.infoNum = JSON.parse(evt.data).notification_total
        }
      };
      webInfoSock.onclose = (evt) => {
        console.log('消息ws开启,页面关闭：', evt);
        // for (let i = 0; i < socknum; i++){
        //   mutations.INIT(state)
        //   socknum--
        // }
      };
      webInfoSock.onerror = (err) => {
        console.log('消息ws出现错误。', err)
        if (this.socknum > 0) {
          mutations.INIT(state)
          socknum--
        }
        // for (let i = 0; i < socknum; i++){
        //   mutations.INIT(state)
        //   socknum--
        // }
      };
    }
  },
  SEND_INFO: (state) => {
    webInfoSock.send(JSON.stringify(state.infoSend))
  },
  SET_INFOSEND: (state, infoSend) => {
    state.infoSend = infoSend;
    webInfoSock.send(JSON.stringify(state.infoSend))
  },
  SET_INFOSENDAROUND: (state, param) => {
    state.infoSend = {
      token: state.token,
      // oid: state.oid
    };
    state.infoSend.send_type = param.send_type;
    if (param.album_qa_id) {
      // 问答id
      state.infoSend.album_qa_id = param.album_qa_id;
    } else if (param.operation_id) {
      // 作业id
      state.infoSend.operation_id = param.operation_id;
    } else if (param.video_id) {
      // 课时id
      state.infoSend.video_id = param.video_id;
    } else if (param.os_type) {
      state.infoSend.os_type = 1
    }
    console.log('消息发送的数据', state.infoSend)
    webInfoSock.send(JSON.stringify(state.infoSend))
  },
  RESET_INFOSEND: (state) => {
    state.infoSend = {
      token: state.token,
      oid: state.oid
    };
  },
  SET_GRADE: (state, grade) => {
    state.grade = grade
  },
  SET_ARRGRADE: (state, arrGrade) => {
    state.arrGrade = arrGrade
  },
  SET_CARDINFO: (state, org) => {
    state.card_info = org;
  },
  SET_VERIFIED: (state, val) => {
    state.stuVerified = val
  },
  SET_CARDNO: (state, card_no) => {
    state.card_no = card_no;
  },
  SET_ORGINFO: (state, org) => {
    state.orgInfo = org
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, ckey, captcha } = userInfo
    return new Promise((resolve, reject) => {
      login({ mobile: username.trim(), password: password, ckey: ckey, captcha: captcha }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.access_token)
        setToken(data.access_token)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getUserGrade().then(res => {
        if (res.status === false) {
          reject(error_msg)
        }
        if (!res.data) {
          reject('Verification failed, please Login again.')
        }
        let grade_id
        if (res.data.length) {
          grade_id = !localStorage.getItem('grade_ID') ? res.data[0].id : localStorage.getItem('grade_ID')
        }

        getInfo({ grade_id }).then(response => {
          if (res.data.length) {
            localStorage.setItem('grade_ID', grade_id)
          }
          const { status, error_msg, data } = response
          const { name, avatar, identity_type, id, oid, card_no, org, is_verified, grade } = data;
          // console.log("===========", data)
          commit('SET_NAME', name);
          commit('SET_AVATAR', avatar);
          commit('SET_IDENTYPE', identity_type);
          commit('SET_LOGINID', id);
          commit('SET_OID', oid);
          commit('SET_GRADE', grade);
          commit('SET_CARDNO', card_no);
          commit('SET_CARDINFO', org);
          commit('SET_VERIFIED', is_verified)

          commit('INIT')

          localStorage.setItem('yktlgId', id)
          resolve(data)
        })
        commit('SET_ARRGRADE', res.data);
      }).catch(error => {
        reject(error)
      })
    })
  },
  // get Org Info
  getOrgInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getOrgInfo().then(response => {
        const { status, error_msg, data } = response
        if (status === false) { reject(error_msg) }
        if (!data) { reject('no data') }
        commit('SET_ORGINFO', data.org);
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        localStorage.removeItem('grade_ID')
        removeToken()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js